exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-langSelector-_yO6u{display:flex;column-gap:20px;color:var(--color-blue-darker,#031764);font-family:Roboto;font-size:16px;font-style:normal;font-weight:500;line-height:24px;letter-spacing:.16px}.style-cssmodule-lang-3GgyA{cursor:pointer;text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"langSelector": "style-cssmodule-langSelector-_yO6u",
	"lang": "style-cssmodule-lang-3GgyA"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/LangSelector2/style.cssmodule.css
// module id = 2528
// module chunks = 121